import {
    TriangleAlert,
    Pencil,
    Save,
    RotateCcw,
    Trash2,
    Check,
    User,
    UserPlus,
    Users,
    UserCheck,
    MapPin,
    MapPinPlus,
    Search,
    Calendar,
    CalendarPlus,
    History,
    Clock,
    ClockPlus,
    ListPlus,
    ClipboardList,
    Printer,
    ReceiptText,
    FileText,
    Settings,
    Info,
    Circle,
    Banknote,
    Mail,
    MailCheck,
    MailX,
    MailWarning,
    Ban,
    Puzzle,
    ThumbsDown,
    ChevronsLeft,
    Send,
    Truck,
    PlusCircle,
    FileX,
    FileSpreadsheet,
    ChevronRight,
    ChevronDown,
    ChevronsDownUp,
    ChevronsUpDown,
    MessageSquare,
    Package,
    PackagePlus,
    PackageCheck,
    Car,
    Camera,
    Route,
    AlertCircle,
    Plus,
    X,
    ShieldOff,
    IdCard,
    Calculator,
    CircleSlash,
    FolderCheck,
    Handshake,
    BadgeCheck,
    CalendarDays,
    Coins,
    Lock,
    LockOpen,
    Utensils,
    Hash,
    RefreshCw,
    Monitor,
    Percent,
    Tv,
    PhoneCall,
    Forklift,
    Square,
    SquareCheck,
    Stamp,
    UserRoundPlus,
    NotebookPen,
    ShieldCheck,
    ListTodo,
    Link,
    ScanBarcode,
    Target,
    ScanSearch,
    ChevronLeft,
    ExternalLink,
    LoaderCircle,
    Play,
    type LucideIconData,
} from 'lucide-angular';

// Re-export all icons for easy importing
export {
    Pencil,
    Save,
    RotateCcw,
    Trash2,
    Check,
    User,
    UserPlus,
    Users,
    UserCheck,
    MapPin,
    MapPinPlus,
    Search,
    Calendar,
    CalendarPlus,
    History,
    Clock,
    ClockPlus,
    ListPlus,
    ClipboardList,
    Printer,
    ReceiptText,
    FileText,
    Settings,
    Info,
    Circle,
    Banknote,
    Mail,
    MailCheck,
    MailX,
    MailWarning,
    Ban,
    Puzzle,
    ThumbsDown,
    ChevronsLeft,
    Send,
    Truck,
    PlusCircle,
    FileX,
    FileSpreadsheet,
    ChevronRight,
    ChevronDown,
    ChevronsDownUp,
    ChevronsUpDown,
    MessageSquare,
    Package,
    PackagePlus,
    PackageCheck,
    Car,
    Camera,
    Route,
    AlertCircle,
    Plus,
    X,
    ShieldOff,
    IdCard,
    Calculator,
    CircleSlash,
    FolderCheck,
    Handshake,
    BadgeCheck,
    CalendarDays,
    Coins,
    Lock,
    LockOpen,
    Utensils,
    Hash,
    RefreshCw,
    Monitor,
    Percent,
    Tv,
    PhoneCall,
    Forklift,
    Square,
    SquareCheck,
    Stamp,
    UserRoundPlus,
    NotebookPen,
    ShieldCheck,
    ListTodo,
    Link,
    ScanBarcode,
    Target,
    ScanSearch,
    ChevronLeft,
    ExternalLink,
    LoaderCircle,
    Play,
    type LucideIconData,
};

// lucide.dev/icons/building-complex-plus, not yet shipped with lucide-angular 1.0.0
export const BuildingComplexPlus: LucideIconData = [
    ['path', { d: 'M10 12h4' }],
    ['path', { d: 'M10 21v-3a2 2 0 0 1 3.05-1.702' }],
    ['path', { d: 'M10 8h4' }],
    ['path', { d: 'M16 19h6' }],
    ['path', { d: 'M18 7h2a2 2 0 0 1 2 2v4.355' }],
    ['path', { d: 'M19 16v6' }],
    ['path', { d: 'M6 10H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h8.535' }],
    ['path', { d: 'M6 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v7.126' }],
];

// Icon mapping from old PNG names to Lucide icons
export const ICON_MAP: Record<string, LucideIconData> = {
    edit_list: Pencil,
    save: Save,
    undo: RotateCcw,
    trashcan_open: Trash2,
    check: Check,
    check_click_green: Check,
    check_click_gray: Check,
    user: User,
    user_add: UserPlus,
    user_list: Users,
    user_group: Users,
    user_ok: UserCheck,
    location: MapPin,
    location_add: MapPinPlus,
    glass: Search,
    event: Calendar,
    event_add: CalendarPlus,
    event_history: History,
    date_time: Clock,
    add_list: ListPlus,
    clipboard: ClipboardList,
    printer: Printer,
    printer_gray: Printer,
    pdf_logo: FileText,
    setting: Settings,
    icon_info_round_blue: Info,
    icon_info_round_gray: Info,
    red_round: Circle,
    yellow_round: Circle,
    orange_round: Circle,
    green_round: Circle,
    gray_round: Circle,
    yellow_green_round: Circle,
    cash: Banknote,
    cash_green: Banknote,
    mail: Mail,
    mail_ok: MailCheck,
    mail_delete: MailX,
    mail_refresh: Send,
    mail_error: MailWarning,
    prohibition: Ban,
    puzzle_blue_changed: Puzzle,
    puzzle_blue_delete: Puzzle,
    red_thumb_down: ThumbsDown,
    move_all_left: ChevronsLeft,
    list_send: Send,
    truck_blue: Truck,
    truck_blue_add: Truck,
    truck_blue_block: Truck,
    truck_yellow_order: Truck,
    add_sign_blue: PlusCircle,
    document_missing: FileX,
    excel_logo: FileSpreadsheet,
    arrow_enum_right_blue: ChevronRight,
    speech_bubble_right: MessageSquare,
    container_blue: Package,
    container_blue_add: PackagePlus,
    box_confirmed: PackageCheck,
    box_request: Package,
    van_gray: Car,
    camera: Camera,
    tour_logo: Route,
    menu_error: AlertCircle,
};

// Color classes for icons that need specific colors
export const ICON_COLORS: Record<string, string> = {
    printer_gray: 'text-gray-400',
    icon_info_round_blue: 'text-blue-500',
    icon_info_round_gray: 'text-gray-400',
    red_round: 'text-red-500 fill-red-500',
    yellow_round: 'text-yellow-500 fill-yellow-500',
    orange_round: 'text-orange-500 fill-orange-500',
    green_round: 'text-green-500 fill-green-500',
    gray_round: 'text-gray-400 fill-gray-400',
    yellow_green_round: 'text-lime-500 fill-lime-500',
    mail: 'text-blue-500',
    mail_ok: 'text-green-500',
    mail_delete: 'text-red-500',
    mail_refresh: 'text-orange-500',
    mail_error: 'text-red-500',
    prohibition: 'text-red-500',
    cash_green: 'text-green-500',
    puzzle_blue_changed: 'text-blue-500',
    puzzle_blue_delete: 'text-blue-500',
    red_thumb_down: 'text-red-500',
    truck_blue: 'text-blue-500',
    truck_blue_add: 'text-blue-500',
    truck_blue_block: 'text-blue-500',
    truck_yellow_order: 'text-yellow-500',
    add_sign_blue: 'text-blue-500',
    arrow_enum_right_blue: 'text-blue-500',
    container_blue: 'text-blue-500',
    container_blue_add: 'text-blue-500',
    van_gray: 'text-gray-400',
    check_click_green: 'text-green-500',
    check_click_gray: 'text-gray-400',
};

// Helper function to extract base name from PNG path
function extractBaseName(pngName: string): string {
    return pngName
        .replace(/_\d+\.png$/, '')
        .replace(/\.png$/, '')
        .replace(
            /^\/?(img\/common\/|img\/store\/|img\/transport\/|hd\/images\/)/,
            ''
        );
}

// Helper function to get icon by old PNG name
export function getIconByName(pngName: string): LucideIconData | undefined {
    return ICON_MAP[extractBaseName(pngName)];
}

// Helper function to get color class by old PNG name
export function getIconColorClass(pngName: string): string {
    return ICON_COLORS[extractBaseName(pngName)] || '';
}

// Registered as `lucide:<name>` for mat-icon, e.g. the side menu
export const MAT_ICON_LUCIDE_ICONS: Record<string, LucideIconData> = {
    utensils: Utensils,
    'notebook-pen': NotebookPen,
    'map-pin': MapPin,
    'shield-check': ShieldCheck,
    'list-todo': ListTodo,
    monitor: Monitor,
    link: Link,
    'rotate-ccw': RotateCcw,
    'scan-barcode': ScanBarcode,
    info: Info,
    'triangle-alert': TriangleAlert,
};

export function lucideSvg(icon: LucideIconData): string {
    const children = icon
        .map(([tag, attrs]) => {
            const attributes = Object.entries(attrs)
                .filter(([name]) => name !== 'key')
                .map(([name, value]) => `${name}="${value}"`)
                .join(' ');
            return `<${tag} ${attributes}/>`;
        })
        .join('');
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${children}</svg>`;
}
